import type { ReactNode } from 'react';
import type { ColumnDef } from '../types';

export function nameWithOptionalCode<T>(
  getName: (item: T) => string,
  getCode: (item: T) => string | null | undefined
): (item: T) => ReactNode {
  return (item) => {
    const name = getName(item);
    const code = getCode(item);
    return (
      <span>
        {name}
        {code ? ` (${code})` : ''}
      </span>
    );
  };
}

export function isSelectedByKey<TItem>(
  getKey: (item: TItem) => string | number
): (item: TItem, selected: readonly TItem[]) => boolean {
  return (item, selected) => selected.some((s) => getKey(s) === getKey(item));
}

interface TextColumnOptions {
  sortable?: boolean;
  emptyDash?: string;
}

export function textColumn<TItem>(
  id: string,
  header: string,
  value: (item: TItem) => ReactNode,
  options?: TextColumnOptions
): ColumnDef<TItem> {
  const emptyDash = options?.emptyDash;
  return {
    id,
    header,
    sortable: options?.sortable,
    cell: (item) => {
      const rendered = value(item);
      if (emptyDash != null && (rendered == null || rendered === '')) {
        return emptyDash;
      }
      return rendered;
    },
  };
}

export const selectorDisplay = {
  nameWithOptionalCode,
  isSelectedByKey,
};

export const selectorColumn = {
  text: textColumn,
};
